import { Rectangle } from 'recharts'
import type { RectangleProps } from 'recharts'

export const BAR_RADIUS: [number, number, number, number] = [4, 4, 0, 0]

/**
 * Bar shape for an actual figure that may carry a forecast stacked on it (USA-1734): square top
 * corners when `restKey` holds a forecast, so the dashed forecast sits flush on the bar.
 */
export function actualBarShape(restKey: string) {
  return function ActualBar(shapeProps: unknown) {
    const props = shapeProps as RectangleProps & { payload?: Record<string, unknown> }
    const forecast = Boolean(props.payload?.[restKey])
    return <Rectangle {...props} radius={forecast ? 0 : BAR_RADIUS} />
  }
}
